import { HttpInterceptorFn } from "@angular/common/http";
import { tap } from "rxjs";
import { inject } from "@angular/core";
import { ApiService } from "../services/api.service";

export const apiTimingInterceptor: HttpInterceptorFn = (req, next) => {
  const apiService = inject(ApiService);
  const shouldOnlyMeasure = [
    "current-user-order",
    "bf_placebet",
    "refresh_exposure",
  ];
  const start = performance.now();
  const strippedUrl = req.url.replace(/^https?:\/\/[^\/]+/, "");

  if (!shouldOnlyMeasure.some((segment: string) => req.url.includes(segment)))
    return next(req);

  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (event.body) {
          const end = performance.now();
          const duration = end - start;
          apiService.apiCallDurations$.set(strippedUrl, duration);
        }
      },
      error: () => {
        const end = performance.now();
        const duration = end - start;
        apiService.apiCallDurations$.set(strippedUrl, duration);
      },
    }),
  );
};
